import './styles/frame.css';
import { Outlet } from "react-router-dom";
import { fetchAuthSession, getCurrentUser, signOut, signInWithRedirect } from 'aws-amplify/auth';
import React, { useEffect, useState } from "react";

export function RequireAdmin({ children }) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // First check if user is authenticated
        const user = await getCurrentUser();
        
        // If user exists, check their groups
        const session = await fetchAuthSession();
        const accessTokenPayload = session.tokens?.accessToken?.payload;
        const groups = accessTokenPayload?.['cognito:groups'] || [];

        if (groups.includes('Administrators')) {
          setAuthorized(true);
        } else {
          console.warn('User not in admin group. Signing out.');
          await signOut();
          // After signing out, redirect to login
          await signInWithRedirect();
        }
      } catch (error) {
        console.warn('User not authenticated. Redirecting to login.');
        // User is not authenticated, redirect to login
        await signInWithRedirect();
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  // Show unauthorized message (this should rarely be seen since we redirect)
  if (!authorized) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: 'red'
      }}>
        Unauthorized - Redirecting to login...
      </div>
    );
  }

  return children;
}

export default function Frame() {
  return (
    <>
      {/* <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-left">
            <a href="/" className="navbar-title">G&F Admin Dashboard</a>
          </div>
          <div className="navbar-right">
            <ul className="navbar-items">
              <li className="navbar-item">
                <a href="/" className="navbar-link">Home</a>
              </li>
              <li className="navbar-item">
                <a href="/orders" className="navbar-link">Orders</a>
              </li>
              <li className="navbar-item">
                <a href="/products" className="navbar-link">Products</a>
              </li>
            </ul>
          </div>
        </div>
      </nav> */}

      <RequireAdmin>
        <Outlet />
      </RequireAdmin>

      {/* <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <a className="footer-title" href="/">Grievers + Friends</a>
          </div>
          <div className="footer-right">
            <ul className="footer-items">
              <li className="footer-item">
                <a href="/" className="footer-link">Home</a>
              </li>
              <li className="footer-item">
                <a href="/about" className="footer-link">About</a>
              </li>
              <li className="footer-item">
                <a href="/services" className="footer-link">Services</a>
              </li>
              <li className="footer-item">
                <a href="/contact" className="footer-link">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </footer> */}
    </>
  );
}